import { useAuth0 } from '@auth0/auth0-react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { CONFIG } from 'src/config';
import { createLaunchDarklyContext } from 'src/utils/createLaunchDarklyContext';

export function LaunchDarklyProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const auth = useAuth0();

  return (
    <LDProvider
      key={auth.user?.sub}
      clientSideID={CONFIG.LaunchDarklyClientId}
      context={createLaunchDarklyContext(auth.user)}
      timeout={5} // seconds
      // Defer initialization to prevent interrupted initialization requests
      deferInitialization
    >
      {children}
    </LDProvider>
  );
}
